import React from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { ROLES } from "../constants/roles";
import { useMediaQuery } from "react-responsive";

const Sidebar = ({ show, handleClose }) => {
  const { hasRole } = useAuth();
  const isDesktop = useMediaQuery({ query: "(min-width: 768px)" });
  
  const renderLinks = (onClickLink = () => {}) => (
    <>
      <h5 className="text-white">Navigation</h5>
      <ul className="list-unstyled">
        <li><Link to="/dashboard" onClick={onClickLink}>Dashboard</Link></li>
        <li><Link to="/schedule" onClick={onClickLink}>View Schedule</Link></li>
        <li><Link to="/standings" onClick={onClickLink}>Standings</Link></li>
        {hasRole(ROLES.LEAGUE_ADMIN) && (
          <>
            <hr style={{ width: "80%", margin: "1rem auto" }} />
            <h5 className="px-3 text-uppercase text-white">Manage</h5>
            <ul className="list-unstyled">

              <li><Link to="/admin-enter-scores" onClick={onClickLink}>Score Management</Link></li>
              <li><Link to="/admin/enter-points" onClick={onClickLink}>Point Management</Link></li>
              <li><Link to="/scorecards" onClick={onClickLink}>Print Scorecards</Link></li>
              <li><Link to="/signin-sheet" onClick={onClickLink}>Print Sign-In Sheet</Link></li>
              <li><Link to="/contest-entry" onClick={onClickLink}>Enter Contest Winners</Link></li>
              <li><Link to="/calculate-handicaps">Calculate Handicaps</Link></li>
		
            </ul>
            <hr style={{ width: "80%", margin: "1rem auto" }} />
            <h5 className="px-3 text-uppercase text-white">Setup</h5>
            <li><Link to="/player-management" onClick={onClickLink}>Player Management</Link></li>
            <li><Link to="/team-management" onClick={onClickLink}>Team Management</Link></li>
            <li><Link to="/message-manager" onClick={onClickLink}>Message Management</Link></li>
            <li><Link to="/schedule-manager" onClick={onClickLink}>Manage Schedule</Link></li>
            <li><Link to="/sub-assignment-manager" onClick={onClickLink}>Manage Subs</Link></li>
            <li><Link to="/schedule-highlights" onClick={onClickLink}>Print Team Schedules</Link></li>
          </>
        )}

        {hasRole(ROLES.APP_ADMIN) && (
          <>
            <hr style={{ width: "80%", margin: "1rem auto" }} />
            <h5 className="px-3 text-uppercase text-white">App Admin</h5>
            <li><Link to="/courses" onClick={onClickLink}>Course Management</Link></li>
            <li><Link to="/leagues" onClick={onClickLink}>League Management</Link></li>
            <li><Link to="/admin-reset-password" onClick={onClickLink}>Reset User Password</Link></li>
          </>
        )}
      </ul>
    </>
  );

  if (isDesktop) {
    return <div className="sidebar">{renderLinks()}</div>;
  }

  return (
    <Offcanvas show={show} onHide={handleClose} placement="start" style={{ width: "240px" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Menu</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{renderLinks(handleClose)}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default Sidebar;
